import { ArrowRightIcon } from '@synergy/theme-next';
import { Box, Divider, MenuItem, MenuItemProps, MenuList, styled } from '@mui/material';
import { Children, ReactElement, useEffect } from 'react';
import { PoolRow, PoolTypography } from '@synergy/components-next';

import { Category } from '../../../../models/category';
import { categoriesSelector } from '../../../../store/categories-selectors';
import { fetchCategories } from '../../../../store/categories-actions';
import { useAppDispatch, useAppSelector } from '../../../../../store/store';

const SlickDivider = styled(Divider)(() => ({
    margin: '0px !important',
}));

export interface CategoryTreeDrawerListProps {
    parentId?: number;
    children?: ReactElement<MenuItemProps> | ReactElement<MenuItemProps>[];
    onCategoryClick?: (category: Category) => void;
    onSelect?: (categoryId: number) => void;
}

export const CategoryTreeDrawerList = (props: CategoryTreeDrawerListProps): ReactElement => {
    const dispatch = useAppDispatch();
    const categories = useAppSelector(state => categoriesSelector(state)(props.parentId));

    useEffect(() => {
        if (props.parentId && categories.length === 0) {
            dispatch(fetchCategories(props.parentId));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dispatch, props.parentId]);

    const handleClick = (category: Category): void => {
        if (category.hasChildren) {
            props.onCategoryClick?.(category);
        } else {
            props.onSelect?.(category.id);
        }
    };

    return (
        <MenuList sx={{ pt: 0 }}>
            {props.parentId ? (
                <MenuItem key={props.parentId} onClick={() => props.onSelect?.(props.parentId ?? 0)}>
                    <PoolRow justifyContent="space-between" sx={{ width: '100%' }}>
                        <Box sx={{ whiteSpace: 'normal' }}>
                            <PoolTypography translationId="app.common.showAll" sx={{ fontWeight: 600 }} />
                        </Box>
                    </PoolRow>
                </MenuItem>
            ) : (
                Children.map(props.children, (child, index) => <MenuItem key={-index} {...child?.props} />)
            )}
            <SlickDivider />
            {categories.map(category => (
                <MenuItem key={category.id} onClick={() => handleClick(category)}>
                    <PoolRow justifyContent="space-between" sx={{ width: '100%' }} gap={1.5}>
                        <Box sx={{ whiteSpace: 'normal' }}>{category.name}</Box>
                        {category.hasChildren && <ArrowRightIcon />}
                    </PoolRow>
                </MenuItem>
            ))}
        </MenuList>
    );
};
